import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import MainLayout from "./layout/Mainlayout";
import Dashboard from "./pages/dashboard";
import Inventory from "./pages/inventory";
import DeviceDetails from "./pages/device-details";
import Alerts from "./pages/alerts";
import AlertDetails from "./pages/alert-details";
import LiveAlerts from "./pages/live-alerts";
import Settings from "./pages/settings";
import UserManagement from "./pages/user-management";
import Login from "./pages/login";
import Performance from "./pages/performance";
import Reports from "./pages/reports";
import AuditLogs from "./pages/audit-logs";
import Help from "./pages/help";
import Notifications from "./pages/notifications";
import ConfigManagement from "./pages/config-management";
import AIConfiguration from "./pages/ai-configuration";
import SlaMonitoring from "./pages/sla-monitoring";
import TestUtilities from "./pages/test-utilities";
import SignUpPage from "./pages/sign-up";
import ForgetPassword from "./pages/forgetPassword";
import Homepage from "./pages/Homepage"
import { UpdateDeviceForm } from "./pages/updateDevice";
import ResetPassword from "./pages/resetPassword";
import ProfilePage from "./pages/ProfilePage";
import AIDashboard from "./pages/AI/ai-dashboard";
import AIInsights from "./pages/AI/ai-insights";
import AnomalyDetection from "./pages/AI/anomaly-detection";
import PredictiveAnalytics from "./pages/AI/predictive-analytics";
import AIReports from "./pages/AI/ai-reports";

function App() {
 

  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route path="/forgot-password" element={<ForgetPassword/>}/>
        <Route path="/reset-password" element={<ResetPassword/>}/>
        <Route path="/" element={<Homepage/>}/>
        <Route element={<MainLayout />}>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/profile"   element={<ProtectedRoute><ProfilePage/></ProtectedRoute>}/>
        <Route path="/user-management" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/manage-devices" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
        <Route path="/device/:id" element={<ProtectedRoute><DeviceDetails /></ProtectedRoute>} />
        <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
        <Route path="/alerts/:id" element={<ProtectedRoute><AlertDetails /></ProtectedRoute>} />
        <Route path="/live-alerts" element={<ProtectedRoute><LiveAlerts /></ProtectedRoute>} />
        <Route path="/performance" element={<ProtectedRoute><Performance /></ProtectedRoute>} />
        {/* <Route path="/network-topology" element={<ProtectedRoute><NetworkTopology /></ProtectedRoute>} /> */}
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/audit-logs" element={<ProtectedRoute><AuditLogs /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/device-management" element={<ProtectedRoute><ConfigManagement /></ProtectedRoute>} />
        <Route path="/ai-configuration" element={<ProtectedRoute><AIConfiguration /></ProtectedRoute>} />
        <Route path="/sla-monitoring" element={<ProtectedRoute><SlaMonitoring /></ProtectedRoute>} />
        <Route path="/test-utilities" element={<ProtectedRoute><TestUtilities /></ProtectedRoute>} />
        <Route path="/help" element={<ProtectedRoute><Help /></ProtectedRoute>} />
        <Route path="/ai-dashboard" element={<ProtectedRoute><AIDashboard /></ProtectedRoute>} />
        <Route path="/ai-insights" element={<ProtectedRoute><AIInsights /></ProtectedRoute>} />
        <Route path="/anomaly-detection" element={<ProtectedRoute><AnomalyDetection /></ProtectedRoute>} />
        <Route path="/predictive-analytics" element={<ProtectedRoute><PredictiveAnalytics /></ProtectedRoute>} />
        <Route path="/ai-reports" element={<ProtectedRoute><AIReports /></ProtectedRoute>} />
        <Route path="/update-device/:id" element={<ProtectedRoute><UpdateDeviceForm /></ProtectedRoute>} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
